import React from 'react';
import { connect } from 'react-redux'
import {
  preferences_index
} from '../actions'
import { Redirect } from 'react-router-dom'

import {
  is_logged_on,
  is_validating
 } from "../helpers"

import Loading from './Loading';
import PreferenceRow from './PreferenceRow'

const mapStateToProps = state => {
  return {
    current_user: state.auth.current_user.data,
    preferences: state.preference.preferences,
    fetching: state.preference.fetching
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getPreferences: () => { dispatch( preferences_index() ) }
  }
}

class ConnectedPreferences extends React.Component {
  constructor() {
    super()
    this.state={
      nowEditing: null
    }
  }

  componentDidMount() {
    this.props.getPreferences()
  }

  initEdit(id) {
    this.setState({
      nowEditing: id
    })
  }

  render () {
    const { preferences, current_user, fetching } = this.props

    if ( ( !is_validating() && !is_logged_on() ) ) {
      return <Redirect to="/" />
    }

    if ( !is_validating() && current_user.role !== "admin" ) {
      window.M.toast({
        html: "Insufficient priviledges"
      })
      return <Redirect to="/" />
    }

    if ( fetching && preferences.length === 0 ) {
      return (
       <Loading />
      )
    }

    return (
      <div className="collection with-header">
        <div className="collection-header red darken-1 white-text">
          <span className="flow-text">Global Preferences</span>
          <i className="material-icons right">settings</i>
        </div>

        <table className="bordered striped highlight responsive-table users-list">
          <thead>
            <tr>
              <th className="padRight">Option</th>
              <th>Value</th>
              <th className="setToRight">Actions</th>
            </tr>
          </thead>
          <tbody>
            {
              Object.keys(preferences).map(function(key){
                const item = preferences[key]
                return (
                  <PreferenceRow key={item.id} preference={item}
                      initEdit={this.initEdit.bind(this)} currentEdit={this.state.nowEditing}
                  />
                )
              }, this)
            }
          </tbody>
        </table>
      </div>
    )
  }
}

const Preferences = connect(mapStateToProps, mapDispatchToProps)(ConnectedPreferences)

export default Preferences



// WEBPACK FOOTER //
// ./src/js/components/Preferences.js